import {IoMdArrowDropdown, IoMdArrowDropup} from "react-icons/io";
export const readMore = <IoMdArrowDropdown size={22} style={{ color: "black" }} />;
export const readLess = <IoMdArrowDropup size={22} style={{ color: "black" }} />;
